module.exports = __webpack_public_path__ + "img/video1.2fe95d37.png";